import React from "react";
import GetInTouch from "./GetInTouch";

const ContactUs = () => {
  return <GetInTouch />;
};

export default ContactUs;
